export function disposeTexture(texture) {
    if (texture.image instanceof HTMLVideoElement) {
        const video = texture.image;
        video.pause();
        video.src = "";
        video.load();
    }
    texture.dispose();
}
class TextureCacheService {
    constructor() {
        this.cache = new Map();
    }
    key(src, version) {
        return `${src}_${version}`;
    }
    set(src, version, texture) {
        this.setTexture(src, version, texture);
    }
    has(src, version) {
        return this.cache.has(this.key(src, version));
    }
    get(src, version) {
        return this.cache.get(this.key(src, version));
    }
    retain(src, version) {
        const item = this.cache.get(this.key(src, version));
        if (!item) {
            console.error(`Retaining uncached texture src ${src}`);
            return undefined;
        }
        item.count++;
        return item;
    }
    release(src, version) {
        const item = this.cache.get(this.key(src, version));
        if (!item) {
            console.error(`Releasing uncached texture src ${src}`);
            return;
        }
        item.count--;
        if (item.count <= 0) {
            disposeTexture(item.texture);
            this.cache.delete(this.key(src, version));
        }
    }
    setTexture(src, version, texture) {
        const item = {
            texture,
            ratio: texture.height / texture.width,
            count: 0
        };
        this.cache.set(this.key(src, version), item);
        return item;
    }
}
export const textureCacheService = new TextureCacheService();
